import App from '@blueberry/containers/App';
import LocaleHandler from '@blueberry/containers/LocaleHandler';

import LoadableHome from '@blueberry/containers/Home/LoadableHome';
import LoadableChannel from '@blueberry/containers/Channel/LoadableChannel';
import LoadablePost from '@blueberry/containers/Post/LoadablePost';
import LoadableCampaign from '@blueberry/containers/Campaign/LoadableCampaign';
import LoadableCampaignResult from '@blueberry/containers/CampaignResult/LoadableCampaignResult';
import LoadableDashboard from '@blueberry/containers/Dashboard/LoadableDashboard';
import LoadableSubjectPage from '@blueberry/containers/SubjectPage/LoadableSubjectPage';
import LoadableSubtopicPage from '@blueberry/containers/SubtopicPage/LoadableSubtopicPage';

import generateLocaleRoutes from './utils/routesGenerator';

import NotFound from '@blueberry/containers/NotFound';

const LOCALE_ROUTES_PREPEND_PATTERN = '/:locale?';

const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: LoadableHome,
        modules: ['Home'],
      },
      // support old url for app
      {
        path: '/post/:id',
        exact: true,
        component: LoadablePost,
        modules: ['Post'],
      },
      {
        path: '/post/:title/:id',
        exact: true,
        component: LoadablePost,
        modules: ['Post'],
      },
      {
        path: '/campaign/:id',
        exact: true,
        component: LoadableCampaign,
        modules: ['Campaign'],
      },
      {
        path: '/campaign/:id/result',
        exact: true,
        component: LoadableCampaignResult,
        modules: ['CampaignResult'],
      },
      {
        path: '/dashboard',
        component: LoadableDashboard,
        modules: ['Dashboard'],
      },
      // FIXME: should change the container name to page
      {
        path: '/page/:name',
        component: LoadableHome,
        modules: ['page'],
      },
      {
        path: '/channel/:id',
        component: LoadableChannel,
        modules: ['channel'],
      },
      {
        // ex: `/subject/math-1/trigonometric-1`
        path: '/subject/:subjectname-:subjectid/:name-:id',
        exact: true,
        component: LoadableSubtopicPage,
        modules: ['subtopicPage'],
      },
      {
        // ex: `/subject/math-1`
        path: '/subject/:name-:id',
        exact: true,
        component: LoadableSubjectPage,
        modules: ['subjectPage'],
      },
    ],
  },
];

/**
 * The purpose of this function is to properly append
 * "localeRoutes" and "not found" routes to main routes.
 *
 * Both locale routes and main routes has NotFound route.
 * NotFound should be placed as the last element of both set of routes:
 *
 * main routes:
 * [
 *   ...
 *   {
 *     path: '/*',
 *     component: NotFound
 *   },
 * ]
 *
 * locale routes:
 * [
 *   ...
 *   {
 *     path: '/:locale?',
 *     component: NotFound,
 *   }
 * ]
 *
 *
 * @todo this is a temporarily hack. routes generator should accept a config
 * to allow certain route to exists only in main route / generated routes.
 */
function appendRoutesToMainRoutes(rootRoutes, localeRoutes) {
  const [rootRoute] = rootRoutes;

  const { routes } = rootRoute;

  localeRoutes[0].routes.push({
    component: NotFound,
  });

  const appendedRoutes = routes.concat(localeRoutes);

  appendedRoutes.push({
    component: NotFound,
  });

  return [
    {
      ...rootRoute,
      routes: appendedRoutes,
    },
  ];
}

const localeRoutes = generateLocaleRoutes(
  routes,
  LOCALE_ROUTES_PREPEND_PATTERN,
  [
    {
      depth: 0,
      pathMatcher: undefined,
      callback: route => ({
        ...route,
        path: LOCALE_ROUTES_PREPEND_PATTERN,
        component: LocaleHandler,
      }),
    },
  ]
);

// @todo a temporatory hack for not found page. fixme.
const resultRoutes = appendRoutesToMainRoutes(routes, localeRoutes);

export default resultRoutes;



// WEBPACK FOOTER //
// ./app/routes.js